import styles from '../../assets/styles/Wallet/Wallet.module.scss'
import React, { useState } from "react";
import { AppPage, Searchbar, PageLoader,  } from "../../components";
import { walletStore } from '../../stores';
import moment from 'moment';
import { AnimatePresence } from "framer-motion";
import { ApproveAccModalContainer } from '../../containers';


const ApproveBank = ({ loading, closeModal, approveRequestModal, goToApproveRequest, requestData }) => {

    const [filteredRequests, setFilteredRequests] = useState([]);

    const accCreateRequest = walletStore.accCreateRequest

    return (
        <AppPage pageTitle="Approve Bank Account">
            {loading ? (
                <PageLoader title="While we set things up for you" />
            ) : (
                <>
                    <div className={styles.searchFilter}>
                        <Searchbar
                            placeholder="Search Requests"
                            variant="wide"
                            input={accCreateRequest}
                            loading={false}
                            output={setFilteredRequests}
                            handleFilter={(item, searchQuery) => {
                                return (
                                    item?.business?.tradingName?.toLowerCase()?.includes(searchQuery)
                                );
                            }}
                        />

                    </div>

                    <div className="whiteTable">
                        <table>
                            <thead>
                                <tr>
                                    <th>Creation Date</th>
                                    <th>Business Name</th>
                                    <th>Business Owner</th>
                                    <th>Kuda Created</th>
                                    <th>Providus Created</th>
                                    <th><div className='status__th'>Status</div></th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRequests.map(item => (
                                    <tr key={item._id}>
                                        <td>{moment(item?.createdAt).format('DD-MM-YY HH:mm A')}</td>
                                        <td>{item?.tradingName}</td>
                                        <td>{item?.user?.firstname} {item?.user?.lastname}</td>
                                        <td>{item.kudaCreated ? "YES" : "NO"}</td>
                                        <td>{item.providusCreated ? "YES" : "NO"}</td>
                                        <td>
                                            <div
                                                className={`status ${item.status === "APPROVED" ? 'status__green' : item.status === "UNPAID" ? 'status__red' : item.status === "VOID" ? 'status__grey' : 'status__dark__yellow'}`}
                                            >
                                                {item?.status}
                                            </div>
                                        </td>
                                        {(!item.kudaCreated || !item.providusCreated) && <td 
                                            className='tableAction__text'
                                            onClick={() => {
                                                    goToApproveRequest(item)
                                                }}
                                        >
                                            Create Bank Account
                                        </td>}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {approveRequestModal && (
                <div className="modal">
                    <AnimatePresence>
                        {approveRequestModal &&
                            <ApproveAccModalContainer
                                closeModal={closeModal}
                                requestData={requestData}
                            />}
                    </AnimatePresence>
                </div>
            )}
        </AppPage>
    )
}

export default ApproveBank;